import { gql } from '@apollo/client';

export const checkoutPaymentError = gql`mutation CheckoutPaymentErrors($id: String!, $input: PaymentErrorInput!) {
    checkoutPaymentErrors(id: $id, input: $input)
  }
`;